import React from "react";
import { connect } from "react-redux";
import routes from "../../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../../common/GridLayout";
import { Toolbar as MainToolbar, Item as MainItem } from 'devextreme-react/toolbar';
import { LoadIndicator } from "devextreme-react/load-indicator";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
const inputRef = React.createRef();
let accessToken = '';
let selectedFile = null;


class ImportInspection extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedItemKeys: [],
      inpectionHeaderRowId: "00000000-0000-0000-0000-000000000000",
      loadIndicatorVisible: false,
      attributeColumns: []
    };

    accessToken = props.oidc.user.access_token;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.rowUpdating = this.rowUpdating.bind(this);
    this.deleteRecords = this.deleteRecords.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
    this.Import = this.Import.bind(this);
    this.AddToDatabase = this.AddToDatabase.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    var that = this;
    this.dataSource = createStore({
      key: 'DetailRowId',
      loadParams:
      {
        inpectionHeaderRowId: function () {
          return that.state.inpectionHeaderRowId;
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.ImportInspection.GetData}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.ImportInspection.UpdateData}`,
      deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.ImportInspection.DeleteData}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }

  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div className="title">
          <h6
            style={{
              color: window._env_.Color2
            }}
          >
            Import Inspections
          </h6>
        </div>
        <DataGrid
          style={{ flex: '1 1 auto', minHeight: 0 }}

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          ref={dataGrid}
          showBorders={true}
          className="ATConfigurationGridStyle"
          selectedRowKeys={this.state.selectedItemKeys}
          onSelectionChanged={this.selectionChanged}
          onRowUpdating={this.rowUpdating}
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Selection mode="multiple" />
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true} />,
          <Sorting mode="multiple" />
          <Editing
            mode="cell"
            newRowPosition="first"
            refreshMode="repaint"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={true} />
          {/* <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={saveState}
          /> */}
          <Column dataField="InspectionId" caption="Inspection Id" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="InspectionDate" caption="Inspection Date" allowEditing={false} cssClass="column-readonly" dataType="date" />
          <Column dataField="Supervisor" caption="Supervisor" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="InspectionType" caption="Inspection Type" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="Orchard" caption="Orchard" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="Block" caption="Block" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="Location" caption="Location" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="Ramet" caption="Ramet" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="Row" caption="Row" dataType="number" allowEditing={false} cssClass="column-readonly" />
          <Column dataField="Column" caption="Column" dataType="number" allowEditing={false} cssClass="column-readonly" />
          <Toolbar>
            <Item location="before">
              <div>Select inspections you want to import</div>
            </Item>
            <Item>
              <input ref={inputRef} id="file-upload" type="file" onChange={this.onFileChange} />
            </Item>
            <Item>
              <LoadIndicator
                style={{
                  height: "20px",
                  width: "20px",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
                visible={this.state.loadIndicatorVisible}
              />
              <Button onClick={this.Import} text="Import" type="default" stylingMode="contained" />
            </Item>
            <Item>
              <Button onClick={this.AddToDatabase} text="Add To Database" type="default" stylingMode="contained" disabled={!this.state.selectedItemKeys.length} />
            </Item>
            <Item>
              <Button
                onClick={this.deleteRecords}
                icon="trash"
                disabled={!this.state.selectedItemKeys.length} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  onFileChange(e) {
    var fileObj = e.target.files && e.target.files[0];
    if (!fileObj) {
      return;
    }
    selectedFile = fileObj;
  }

  /* deleteRecords()
  {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          that.state.selectedItemKeys.forEach((key) => {
            dataGrid.current.instance().getDataSource().store().remove(key);
          });

          that.setState({
            selectedItemKeys: [],
          });

          dataGrid.current.instance().refresh();

        }
    });

  } */

  deleteRecords() {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
      if (dialogResult) {
        dataGrid.current.instance().beginCustomLoading("Deleting");
        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.ImportInspection.DeleteRecords}`,
            that.state.selectedItemKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

      }
    });
  }

  Import(e) {
    if (selectedFile == null) {
      alert("select a file first", "Error");
      return;
    }
    var ext = selectedFile.name.substr(selectedFile.name.lastIndexOf('.') + 1);

    if (ext != "csv") {
      alert("file extenstion should be csv", "Error");
      return;
    }

    // Create an object of formData
    const formData = new FormData();
    // Update the formData object
    formData.append(
      "File",
      selectedFile
    );

    this.setState({
      loadIndicatorVisible: true
    });

    var that = this;
    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.ImportInspection.ImportCSV}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((res) => {

      that.setState({
        loadIndicatorVisible: false
      });

      if (res.data.success) {
        inputRef.current.value = null;
        selectedFile = null;

        for (var i = 0; i < that.state.attributeColumns.length; i++) {
          dataGrid.current.instance().deleteColumn(that.state.attributeColumns[i].dataField);
        }

        for (var i = 0; i < res.data.columns.length; i++) {
          dataGrid.current.instance().addColumn(res.data.columns[i]);
        }

        /*
        dataGrid.current.instance().addColumn({
          dataField: 'Question1',
          caption: 'Question 1',
          dataType: 'string'
          });

        dataGrid.current.instance().addColumn({
          dataField: 'Question2',
          caption: 'Question 2',
          dataType: 'string'
          });
        */

        that.setState({
          inpectionHeaderRowId: res.data.inspectionheaderrowid,
          attributeColumns: res.data.columns
        });

        dataGrid.current.instance().refresh();
      }
      else {
        alert(res.data.message, "Error");
      }


    })
      .catch((err) => {
        that.setState({
          loadIndicatorVisible: false
        });
        alert(err, "Error");
      });

    /*
    dataGrid.current.instance().option("columns", ['CompanyName', 'City', 'State', 'Phone', 'Fax']);
    dataGrid.current.instance().option("dataSource", [{
      ID: 1,
      CompanyName: 'Super Mart of the West',
      Address: '702 SW 8th Street',
      City: 'Bentonville',
      State: 'Arkansas',
      Zipcode: 72716,
      Phone: '(800) 555-2797',
      Fax: '(800) 555-2171',
      Website: 'http://www.nowebsitesupermart.com'
    }]);
    */

    /*
    let result = confirm("<i>This will change dates. Do you wish to conitnue?</i>", "Subtract a Year");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Updating");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.maintenance.StratificationDateSubtractYear}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });
    */
  }

  AddToDatabase(e) {

    if (this.state.selectedItemKeys == null && this.state.selectedItemKeys.length <= 0) {
      alert("select one or more records", "Error");
      return;
    }

    this.setState({
      loadIndicatorVisible: true
    });
    var that = this;
    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.ImportInspection.AddToDatabase}`,
      {
        inspectionHeaderrowid: this.state.inpectionHeaderRowId,
        inspectiondetails: this.state.selectedItemKeys
      },
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((res) => {

      that.setState({
        loadIndicatorVisible: false
      });

      if (res.data.success) {
        for (var i = 0; i < that.state.attributeColumns.length; i++) {
          dataGrid.current.instance().deleteColumn(that.state.attributeColumns[i].dataField);
        }

        that.setState(
          {
            inpectionHeaderRowId: "00000000-0000-0000-0000-000000000000",
            attributeColumns: []
          });

        dataGrid.current.instance().refresh();
      }
      else {
        alert(res.data.message, "Error");
      }

    })
      .catch((err) => {
        that.setState({
          loadIndicatorVisible: false
        });
        alert(err, "Error");
      });

    /*
    dataGrid.current.instance().option("columns", ['CompanyName', 'City', 'State', 'Phone', 'Fax']);
    dataGrid.current.instance().option("dataSource", [{
      ID: 1,
      CompanyName: 'Super Mart of the West',
      Address: '702 SW 8th Street',
      City: 'Bentonville',
      State: 'Arkansas',
      Zipcode: 72716,
      Phone: '(800) 555-2797',
      Fax: '(800) 555-2171',
      Website: 'http://www.nowebsitesupermart.com'
    }]);
    */

    /*
    let result = confirm("<i>This will change dates. Do you wish to conitnue?</i>", "Subtract a Year");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Updating");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.maintenance.StratificationDateSubtractYear}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });
    */
  }

  selectionChanged(data) {
    this.setState({
      selectedItemKeys: data.selectedRowKeys,
    });
  }

  rowUpdating(e) {
    if (!e.newData.hasOwnProperty('RowId')) {
      e.newData['RowId'] = e.oldData['RowId'];
    }
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ImportInspection);
